import React from "react";
import DefaultTermTemplate from "./DefaultTermTemplate";
import USTermTemplate from "./USTermTemplate";
import type { LandingPageConfig } from "landing/objects/LandingPageConfig";

export interface ITermTemplateProps {
  landingPageConfig: LandingPageConfig;
}

export const TermTemplate = ({ landingPageConfig }: ITermTemplateProps) => {
  const { showsUSTerm } = landingPageConfig;
  if (showsUSTerm) {
    return <USTermTemplate landingPageConfig={landingPageConfig} />;
  } else {
    return <DefaultTermTemplate landingPageConfig={landingPageConfig} />;
  }
};
